import { Metadata } from './metadata'

export interface Namespace {
  metadata: Metadata;
}

export class NamespaceAPI {
  public static getAll (cb: (ns: Namespace[]) => void) {
    fetch('/api/v1/namespaces').then(response => {
      if (response.ok) {
        response.json().then(
          data => cb(data.items)
        )
      } else if (response.status === 403) {
        // hack for demo where listing namespaces is not allowed
        const fakeNamespaces = [{
          metadata: {
            name: 'default'
          }
        },
        {
          metadata: {
            name: 'fission-apt'
          }
        }]

        cb(fakeNamespaces)
      }
    })
  }
}
